import { useParams } from "react-router-dom";
import { OverviewTab } from "v2/components/entityDocuments/OverviewTab";

export const EntityProfile = () => {
  const { entityId = "" } = useParams<{ entityId: string }>();

  return (
    <div className="t-flex t-w-full t-flex-col t-gap-4">
      <OverviewTab entityId={entityId} />
    </div>
  );
};
